module.exports = __webpack_public_path__ + "static/media/supportLanding.5457e4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/supportLanding.png
// module id = 1235
// module chunks = 0